<div class="clock-down">
    <div class="progress-circle" [style.--percent-circle]="this.percentTime">
        <div class="box-circle">
            <div class="percent">
                <svg>
                    <circle cx="22" cy="22" r="22"></circle>
                    <circle cx="22" cy="22" r="22"></circle>
                </svg>
            </div>
        </div>
    </div>
    <div class="clock">
        <p>El código vence en:</p>
        <p> <b>{{time.minutes}}:{{time.seconds}} minutos</b></p>
    </div>
</div>